export default "__VITE_ASSET__DabOASRw__"